/* tslint:disable */
import {
  IncomeInvoice,
  UserProfile
} from '../index';

declare var Object: any;
export interface IncomeInvoiceEditMemoInterface {
  "memo": string;
  "invoice_id": number;
  "lease_id": string;
  "archive": any;
  "user_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  incomeInvoice?: IncomeInvoice;
  userProfile?: UserProfile;
}

export class IncomeInvoiceEditMemo implements IncomeInvoiceEditMemoInterface {
  "memo": string;
  "invoice_id": number;
  "lease_id": string;
  "archive": any;
  "user_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  incomeInvoice: IncomeInvoice;
  userProfile: UserProfile;
  constructor(data?: IncomeInvoiceEditMemoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `IncomeInvoiceEditMemo`.
   */
  public static getModelName() {
    return "IncomeInvoiceEditMemo";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of IncomeInvoiceEditMemo for dynamic purposes.
  **/
  public static factory(data: IncomeInvoiceEditMemoInterface): IncomeInvoiceEditMemo{
    return new IncomeInvoiceEditMemo(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'IncomeInvoiceEditMemo',
      plural: 'IncomeInvoiceEditMemos',
      path: 'IncomeInvoiceEditMemos',
      idName: 'id',
      properties: {
        "memo": {
          name: 'memo',
          type: 'string'
        },
        "invoice_id": {
          name: 'invoice_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'string'
        },
        "archive": {
          name: 'archive',
          type: 'any'
        },
        "user_id": {
          name: 'user_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        incomeInvoice: {
          name: 'incomeInvoice',
          type: 'IncomeInvoice',
          model: 'IncomeInvoice',
          relationType: 'belongsTo',
                  keyFrom: 'invoice_id',
          keyTo: 'id'
        },
        userProfile: {
          name: 'userProfile',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'user_id',
          keyTo: 'id'
        },
      }
    }
  }
}
